import { Expose, Type } from 'class-transformer'
import { Package } from 'react-feather'

import { Barcode } from './Barcode'
import { Base } from './Base'

export class CaseBase extends Base {
  static type = 'case'
  static typeDisplay = 'Case'
  static icon = Package

  type = CaseBase.type
  typeDisplay = CaseBase.typeDisplay
  icon = CaseBase.icon

  @Expose({ name: 'xid' })
  guid: string = ''
  
  name: string = ''

  @Expose({ name: 'num_units' })
  numUnits: number = 0

  @Type(() => Barcode)
  @Expose({ name: 'primary_barcode' })
  primaryBarcode?: Barcode
}
